import { c as _c } from "react/compiler-runtime";
import { CREATE_DRAFT_API_URL } from "@website/accommodation-ui/constant/addresses";
import { fetcher } from "@website/fetcher/fetcher";
import { useMutation } from "@website/fetcher/use-fetcher";
import { useRouter } from "next/router";
export const useCreateDraft = (solutionId, id) => {
  const $ = _c(7);
  const router = useRouter();
  let t0;
  if ($[0] !== id || $[1] !== router || $[2] !== solutionId) {
    t0 = {
      mutationFn: () => fetcher({
        url: CREATE_DRAFT_API_URL,
        method: "POST",
        data: {
          solutionId
        }
      }).then(t1 => {
        const {
          data
        } = t1;
        router.push(`/booking/${data.trackingCode}?searchId=${id}`);
        return data;
      })
    };
    $[0] = id;
    $[1] = router;
    $[2] = solutionId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    isPending,
    mutate
  } = useMutation(t0);
  let t1;
  if ($[4] !== isPending || $[5] !== mutate) {
    t1 = {
      isPending,
      mutate
    };
    $[4] = isPending;
    $[5] = mutate;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};